module.exports = __webpack_public_path__ + "img/go-to-allocated-coupons.3d080459.svg";